// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addressBookStyles } from "@insite/content-library/Widgets/Addresses/AddressBook";
import Edit from "@insite/mobius/Icons/Edit";
import dataTableStyles from "@sc/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { color, createLinkIconStyles } from "@sc/XDL/Utilities";
import { css } from "styled-components";

addressBookStyles.addressCard = {
    actionUseAsShippingAddressButton: {
        variant: "secondary",
        css: css`
            min-width: 200px;
        `,
    },
    actionEditLink: {
        ...createLinkIconStyles(Edit, {
            css: css`
                display: flex;
                justify-content: center;
                margin-top: 15px;
                margin-inline: auto;
            `,
        }),
    },
    gridContainer: { gap: 20 },
    addressInfoDisplayGridItem: { width: [10, 10, 5, 7, 7] },
    actionsGridItem: {
        width: [2, 2, 7, 5, 5],
        css: css`
            justify-content: flex-end;
        `,
    },
    bottomBorderGridItem: { width: 12 },
    bottomBorder: {
        css: css`
            height: 1px;
            background-color: ${color("common.border")};
            width: 100%;
        `,
    },
};

addressBookStyles.noAddressesText = { ...dataTableStyles.noResultsText };

addressBookStyles.centeringWrapper = {
    css: css`
        height: 300px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    `,
};
